import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ColorTimeRow, StrikeService } from 'src/app/Services/StrikeService/StrikeService.service';

@Component({
  selector: 'app-RytmicColorRamp',
  templateUrl: './RytmicColorRamp.component.html',
  styleUrls: ['./RytmicColorRamp.component.css']
})
export class RytmicColorRampComponent implements OnInit {
  public colorRamp:ColorTimeRow[];
  constructor(
    public strikeService:StrikeService,
    public dialogRef: MatDialogRef<RytmicColorRampComponent>,
  ) {
    this.colorRamp = Object.assign([], this.strikeService.colorRamp);
  }

  ngOnInit() {
  }

  onDismiss(): void {
    // Close the dialog, return false


    this.dialogRef.close(false);
  }

  update()
  {
    this.strikeService.colorRampUpdate(this.colorRamp);
    this.dialogRef.close(false);
  }
  public colorUpdate(e,num:number)
  {
    var f = this.colorRamp.find((t)=>{
      return t.time == num
    })
    if(f)
    {
      var index = this.colorRamp.indexOf(f);
      this.colorRamp[index].color=e.currentTarget.value;
    }

  }

}
